import { useMemo } from 'react';
import { useVideoMaker } from '../useVideoMaker';
import { EditScenarioFirstScreen } from '../useVideoMaker/videoMaker.types';
import { IUseVideoMakerActions } from './actions.types';

export const useVideoMakerActions = ({ file }: IUseVideoMakerActions) => {
  const { openVideoMaker } = useVideoMaker();

  return useMemo(
    () => ({
      editVideoAction: () => {
        openVideoMaker({ fileId: file.id });
      },
      shareVideoAction: () => {
        openVideoMaker({
          fileId: file.id,
          editScenarioFirstScreen: EditScenarioFirstScreen.Save,
        });
      },
      duplicateVideoAction: () => {
        openVideoMaker({
          fileId: file.id,
          editScenarioFirstScreen: EditScenarioFirstScreen.Customize,
        });
      },
    }),
    [file, openVideoMaker],
  );
};
